export function getDecimals(currency) {
    return currencies[currency] ? currencies[currency].decimals : 2;
}
export function toMajorUnits(amount, currency) {
    return amount / Math.pow(10, getDecimals(currency));
}
export function toMinorUnits(amount, currency) {
    return Math.round(amount * Math.pow(10, getDecimals(currency)));
}
export var Currencies;
(function (Currencies) {
    Currencies["USD"] = "USD";
    Currencies["SEK"] = "SEK";
    Currencies["DKK"] = "DKK";
    Currencies["GBP"] = "GBP";
    Currencies["NOK"] = "NOK";
    Currencies["EUR"] = "EUR";
    Currencies["JPY"] = "JPY";
    Currencies["PLN"] = "PLN";
    Currencies["CAD"] = "CAD";
})(Currencies || (Currencies = {}));
export const currencies = {
    AED: { code: 'AED', decimals: 2 },
    AFN: { code: 'AFN', decimals: 2 },
    ALL: { code: 'ALL', decimals: 2 },
    AMD: { code: 'AMD', decimals: 2 },
    ANG: { code: 'ANG', decimals: 2 },
    AOA: { code: 'AOA', decimals: 2 },
    ARS: { code: 'ARS', decimals: 2 },
    AUD: { code: 'AUD', decimals: 2 },
    AWG: { code: 'AWG', decimals: 2 },
    AZN: { code: 'AZN', decimals: 2 },
    BAM: { code: 'BAM', decimals: 2 },
    BBD: { code: 'BBD', decimals: 2 },
    BDT: { code: 'BDT', decimals: 2 },
    BGN: { code: 'BGN', decimals: 2 },
    BHD: { code: 'BHD', decimals: 2 },
    BIF: { code: 'BIF', decimals: 2 },
    BMD: { code: 'BMD', decimals: 2 },
    BND: { code: 'BND', decimals: 2 },
    BOB: { code: 'BOB', decimals: 2 },
    BRL: { code: 'BRL', decimals: 2 },
    BSD: { code: 'BSD', decimals: 2 },
    BTN: { code: 'BTN', decimals: 2 },
    BWP: { code: 'BWP', decimals: 2 },
    BYN: { code: 'BYN', decimals: 2 },
    BZD: { code: 'BZD', decimals: 2 },
    CAD: { code: 'CAD', decimals: 2 },
    CDF: { code: 'CDF', decimals: 2 },
    CHF: { code: 'CHF', decimals: 2 },
    CLP: { code: 'CLP', decimals: 0 },
    CNY: { code: 'CNY', decimals: 2 },
    COP: { code: 'COP', decimals: 2 },
    CRC: { code: 'CRC', decimals: 2 },
    CUP: { code: 'CUP', decimals: 2 },
    CVE: { code: 'CVE', decimals: 2 },
    CZK: { code: 'CZK', decimals: 2 },
    DJF: { code: 'DJF', decimals: 2 },
    DKK: { code: 'DKK', decimals: 2 },
    DOP: { code: 'DOP', decimals: 2 },
    DZD: { code: 'DZD', decimals: 2 },
    EGP: { code: 'EGP', decimals: 2 },
    ERN: { code: 'ERN', decimals: 2 },
    ETB: { code: 'ETB', decimals: 2 },
    EUR: { code: 'EUR', decimals: 2 },
    FJD: { code: 'FJD', decimals: 2 },
    FKP: { code: 'FKP', decimals: 2 },
    GBP: { code: 'GBP', decimals: 2 },
    GEL: { code: 'GEL', decimals: 2 },
    GHS: { code: 'GHS', decimals: 2 },
    GIP: { code: 'GIP', decimals: 2 },
    GMD: { code: 'GMD', decimals: 2 },
    GNF: { code: 'GNF', decimals: 2 },
    GTQ: { code: 'GTQ', decimals: 2 },
    GYD: { code: 'GYD', decimals: 2 },
    HKD: { code: 'HKD', decimals: 2 },
    HNL: { code: 'HNL', decimals: 2 },
    HTG: { code: 'HTG', decimals: 2 },
    HUF: { code: 'HUF', decimals: 2 },
    IDR: { code: 'IDR', decimals: 0 },
    ILS: { code: 'ILS', decimals: 2 },
    INR: { code: 'INR', decimals: 2 },
    IQD: { code: 'IQD', decimals: 2 },
    IRR: { code: 'IRR', decimals: 2 },
    ISK: { code: 'ISK', decimals: 0 },
    JMD: { code: 'JMD', decimals: 2 },
    JOD: { code: 'JOD', decimals: 2 },
    JPY: { code: 'JPY', decimals: 0 },
    KES: { code: 'KES', decimals: 2 },
    KGS: { code: 'KGS', decimals: 2 },
    KHR: { code: 'KHR', decimals: 2 },
    KMF: { code: 'KMF', decimals: 2 },
    KPW: { code: 'KPW', decimals: 2 },
    KRW: { code: 'KRW', decimals: 0 },
    KWD: { code: 'KWD', decimals: 2 },
    KYD: { code: 'KYD', decimals: 2 },
    KZT: { code: 'KZT', decimals: 2 },
    LAK: { code: 'LAK', decimals: 2 },
    LBP: { code: 'LBP', decimals: 2 },
    LKR: { code: 'LKR', decimals: 2 },
    LRD: { code: 'LRD', decimals: 2 },
    LSL: { code: 'LSL', decimals: 2 },
    LYD: { code: 'LYD', decimals: 2 },
    MAD: { code: 'MAD', decimals: 2 },
    MDL: { code: 'MDL', decimals: 2 },
    MGA: { code: 'MGA', decimals: 2 },
    MKD: { code: 'MKD', decimals: 2 },
    MMK: { code: 'MMK', decimals: 2 },
    MNT: { code: 'MNT', decimals: 2 },
    MOP: { code: 'MOP', decimals: 2 },
    MRU: { code: 'MRU', decimals: 2 },
    MUR: { code: 'MUR', decimals: 2 },
    MVR: { code: 'MVR', decimals: 2 },
    MWK: { code: 'MWK', decimals: 2 },
    MXN: { code: 'MXN', decimals: 2 },
    MYR: { code: 'MYR', decimals: 2 },
    MZN: { code: 'MZN', decimals: 2 },
    NAD: { code: 'NAD', decimals: 2 },
    NGN: { code: 'NGN', decimals: 2 },
    NIO: { code: 'NIO', decimals: 2 },
    NOK: { code: 'NOK', decimals: 2 },
    NPR: { code: 'NPR', decimals: 2 },
    NZD: { code: 'NZD', decimals: 2 },
    OMR: { code: 'OMR', decimals: 2 },
    PAB: { code: 'PAB', decimals: 2 },
    PEN: { code: 'PEN', decimals: 2 },
    PGK: { code: 'PGK', decimals: 2 },
    PHP: { code: 'PHP', decimals: 2 },
    PKR: { code: 'PKR', decimals: 2 },
    PLN: { code: 'PLN', decimals: 2 },
    PYG: { code: 'PYG', decimals: 0 },
    QAR: { code: 'QAR', decimals: 2 },
    RON: { code: 'RON', decimals: 2 },
    RSD: { code: 'RSD', decimals: 2 },
    RUB: { code: 'RUB', decimals: 2 },
    RWF: { code: 'RWF', decimals: 2 },
    SAR: { code: 'SAR', decimals: 2 },
    SBD: { code: 'SBD', decimals: 2 },
    SCR: { code: 'SCR', decimals: 2 },
    SDG: { code: 'SDG', decimals: 2 },
    SEK: { code: 'SEK', decimals: 2 },
    SGD: { code: 'SGD', decimals: 2 },
    SHP: { code: 'SHP', decimals: 2 },
    SLL: { code: 'SLL', decimals: 2 },
    SOS: { code: 'SOS', decimals: 2 },
    SRD: { code: 'SRD', decimals: 2 },
    SSP: { code: 'SSP', decimals: 2 },
    STN: { code: 'STN', decimals: 2 },
    SYP: { code: 'SYP', decimals: 2 },
    SZL: { code: 'SZL', decimals: 2 },
    THB: { code: 'THB', decimals: 2 },
    TJS: { code: 'TJS', decimals: 2 },
    TMT: { code: 'TMT', decimals: 2 },
    TND: { code: 'TND', decimals: 2 },
    TOP: { code: 'TOP', decimals: 2 },
    TRY: { code: 'TRY', decimals: 2 },
    TTD: { code: 'TTD', decimals: 2 },
    TWD: { code: 'TWD', decimals: 2 },
    TZS: { code: 'TZS', decimals: 2 },
    UAH: { code: 'UAH', decimals: 2 },
    UGX: { code: 'UGX', decimals: 2 },
    USD: { code: 'USD', decimals: 2 },
    UYU: { code: 'UYU', decimals: 2 },
    UZS: { code: 'UZS', decimals: 2 },
    VES: { code: 'VES', decimals: 2 },
    VND: { code: 'VND', decimals: 0 },
    VUV: { code: 'VUV', decimals: 2 },
    WST: { code: 'WST', decimals: 2 },
    XAF: { code: 'XAF', decimals: 2 },
    XCD: { code: 'XCD', decimals: 2 },
    XOF: { code: 'XOF', decimals: 2 },
    XPF: { code: 'XPF', decimals: 2 },
    YER: { code: 'YER', decimals: 2 },
    ZAR: { code: 'ZAR', decimals: 2 },
    ZMW: { code: 'ZMW', decimals: 2 },
    ZWL: { code: 'ZWL', decimals: 2 },
};
/**
 * Returns true if decimals should be shown on the site for the given currency code.
 * By default, uses the decimals value from the currencies list, but can override for specific currencies.
 * @param currency - The currency code (e.g. 'SEK', 'DKK', 'NOK', 'JPY', ...)
 */
export function shouldShowDecimalsOnSite(currency) {
    const overrideNoDecimals = new Set(['SEK', 'DKK', 'NOK']);
    if (overrideNoDecimals.has(currency.toUpperCase()))
        return false;
    const decimals = getDecimals(currency.toUpperCase());
    return decimals > 0;
}
